import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';

export default function withScrollToTop(WrappedComponent) {
    class ComponentWithScrollToTop extends Component {
        componentDidUpdate(prevProps) {
            if (this.props.location !== prevProps.location) {
                window.scrollTo(0, 0);
            }
        }

        render() {
            return <WrappedComponent {...this.props} />;
        }
    }

    return withRouter(ComponentWithScrollToTop);
}



// WEBPACK FOOTER //
// ./js/common/components/withScrollToTop.jsx